module.exports = __webpack_public_path__ + "img/5.cb814a38.jpg";